<template>
  <div class="work-order-detail">
    <el-row :gutter="20">
      <el-col :span="12">
        <work-order-status-info
          :work-order="wkDetailInfo"
        ></work-order-status-info>
        <work-order-base-info
          :work-order="wkDetailInfo"
          label-width="110px"
        ></work-order-base-info>
        <work-order-apply-info
          :work-order="wkDetailInfo"
          label-width="110px"
        ></work-order-apply-info>
        <work-order-user-info
          :work-order="wkDetailInfo"
          label-width="110px"
        ></work-order-user-info>
        <work-order-more-info
          :work-order="wkDetailInfo"
          label-width="110px"
          @refresh="getMyDealWorkOrderDetail"
        ></work-order-more-info>
      </el-col>
      <el-col :span="12">
        <work-order-card :isShowHeader="false">
          <work-order-tool
            slot="card-body"
            :work-order="wkDetailInfo"
            @refresh="getMyDealWorkOrderDetail"
          ></work-order-tool>
        </work-order-card>
        <el-card style="margin-bottom: 10px">
          <work-order-process :work-order="wkDetailInfo"></work-order-process>
        </el-card>
      </el-col>
    </el-row>
    <temp-dialog></temp-dialog>
  </div>
</template>

<script>
import api from "plus/api";

export default {
  name: "work.myAccept.detail",
  components: {},
  data() {
    return {
      wkDetailInfo: {},
    };
  },
  computed: {
    wkOrderId() {
      return this.$route.query.wkOrderId;
    },
    id() {
      return this.$route.query.id;
    },
  },
  activated() {
    this.getMyDealWorkOrderDetail();
  },
  deactivated() {
    this.resetData();
  },
  methods: {
    resetData() {
      this.wkDetailInfo = {};
    },
    getMyDealWorkOrderDetail() {
      return api.work
        .getWorkDetail({ id: this.id })
        .then((res) => {
          const data = res.data.data;
          this.wkDetailInfo = data;
        })
        .catch((err) => {});
    },
  },
};
</script>

<style lang="less" scoped>
.work-order-detail {
  width: 100%;

  .detail-header {
    width: 100%;
    background: #fff;
  }

  .quill-editor-container {
    padding-bottom: 32px;

    .quill-editor {
      padding: 20px 47px 20px 95px;
      height: 365px;

      /deep/ .ql-container {
        height: calc(100% - 42px);
      }
    }

    .quill-editor-options-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-left: 95px;
      padding-right: 47px;

      .upload-file {
        font-size: 14px;

        .upload-text-btn {
          color: #3572e2;
          margin-right: 12px;
        }

        .upload-limit {
          color: #999;
        }
      }

      .quill-editor-button-box {
        .el-button {
          width: 104px;
          height: 36px;
          border-radius: 2px;
          font-size: 14px;
        }
      }
    }
  }

  .record {
    width: 100%;
    margin-top: 30px;

    .record-container {
      padding-left: 16px;
      box-sizing: border-box;
    }
  }
}
</style>
